module.exports = __webpack_public_path__ + "img/1-2.f85d1374.png";